import { useState } from "react";
import { useEffect } from "react";
import { fetch, key, trans } from "../../lib/utils";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import DatetimeEditor from "../editors/datetimeEditor";
import store from "../../stores/store";
import BootstrapTable from "react-bootstrap-table-next";

function CSWPanel() {
  const cswcriteria = useSelector(
    (state) => store.getState().searchCSW.criteria
  );

  const sources = useSelector((state) => store.getState().sources);

  const [cswServices, setCSWServices] = useState([]);

  const leftPanelActiveTab = useSelector(
    (state) => state.app.leftPanelActiveTab
  );

  useEffect(() => {
    let _cswServices = [];

    Object.keys(sources)?.map((el) => {
      if (sources[el].type === "CSW") {
        _cswServices.push(sources[el]);
      }
    });

    setCSWServices(_cswServices);

    setTimeout(window["recaclulatePerfectScrollbarHeight"], 100);
  }, [sources, leftPanelActiveTab]);

  const search = () => {
    let resultsKey = key();

    cswcriteria.services?.forEach((el) => {
      let sourceId = el.id;
      let url =
        "metadataSearch.php?profile=1&search_request_method=advance&metadata_servers=[".concat(
          el.url,
          "]&title={title}&abstract={abstract}&resourceidentifier={resourceidentifier}&type={type}&keyword={keyword}&topiccategory={topiccategory}&from={from}&to={to}&calendartype={calendartype}&organisationname={organisationname}&responsiblepartyrole={responsiblepartyrole}&conditionapplyingtoaccessanduse={conditionapplyingtoaccessanduse}&accessconstraints={accessconstraints}&lineage={lineage}&specificationtitle={specificationtitle}&denominator={denominator}&distancevalue={distancevalue}&distanceuom={distanceuom}&degree={degree}&bbox={bbox}&tight=false&page=1&limit=1000&start=0"
        );

      let replaceParams = [
        "title",
        "abstract",
        "resourceidentifier",
        "type",
        "keyword",
        "topiccategory",
        "from",
        "to",
        "calendartype",
        "organisationname",
        "responsiblepartyrole",
        "conditionapplyingtoaccessanduse",
        "accessconstraints",
        "lineage",
        "specificationtitle",
        "denominator",
        "distancevalue",
        "distanceuom",
        "degree",
        "bbox",
      ];

      replaceParams.forEach((el) => {
        if (cswcriteria[el]) {
          url = url.replace("{".concat(el, "}"), cswcriteria[el]);
        } else {
          if (el === "bbox") {
            url = url.replace("{bbox}", "-180,-90,180,90");
          } else {
            url = url.replace("{".concat(el, "}"), "");
          }
        }
      });

      fetch(window["appConfig"]()["api"](url), "GET", {}, [], (resp) => {
        if (resp) {
          if (resp.data) {
            if (resp.data.rows) {
              if (resp.data.rows.length > 0) {
                store.dispatch({
                  type: "results/cswResults/add",
                  payload: {
                    data: resp.data.rows,
                    params: {
                      total: resp.data.results,
                      searchKey: resultsKey,
                      criteria: { ...cswcriteria },
                    },
                    source: sourceId,
                  },
                });
              }
            }
          }
        }
      });
    });
  };

  const updateSelectedServices = (selected) => {
    let selectedFiltered = cswcriteria.services
      ? [...cswcriteria.services]
      : [];

    if (Array.isArray(selected)) {
      selectedFiltered = [...selected];
    } else {
      let selectedExistIndex = null;

      selectedFiltered?.forEach((el, idx) => {
        if (selected.id === el.id) {
          selectedExistIndex = idx;
        }
      });

      if (selectedExistIndex !== null) {
        selectedFiltered.splice(selectedExistIndex, 1);
      } else {
        selectedFiltered.push(selected);
      }
    }

    store.dispatch({
      type: "csw/search/criteria",
      payload: {
        property: "services",
        value: selectedFiltered,
      },
    });
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (data, isSelected) => {
      updateSelectedServices(data);
    },
    selected: cswcriteria?.services
      ? cswcriteria.services.map((el) => {
          return el.id;
        })
      : [],
    onSelectAll: (isSelected, data, e) => {
      updateSelectedServices(data);
    },
  };

  return (
    <div className="mt-2 ms-2 me-2">
      <ul className="nav nav-tabs navbar-expand small ">
        <li
          className="nav-item "
          role="button"
          onClick={() => {
            window["recaclulatePerfectScrollbarHeight"]();
          }}
        >
          <span
            className="nav-link color-strong-grey nav-ellipsis  active"
            data-bs-toggle="tab"
            data-bs-target="#cws-criteria"
          >
            <span className="color-black">{trans("Search criteria")}</span>
          </span>
        </li>
        <li
          className="nav-item "
          role="button"
          onClick={() => {
            window["recaclulatePerfectScrollbarHeight"]();
          }}
        >
          <span
            className="nav-link color-strong-grey nav-ellipsis "
            data-bs-toggle="tab"
            data-bs-target="#cws-services"
          >
            <span className="color-black">{trans("CSW Services")}</span>
          </span>
        </li>
      </ul>
      <div className="tab-content mt-2">
        <div
          className="tab-pane fade show active "
          role="tabpanel"
          id="cws-criteria"
        >
          {cswcriteria?.services?.length > 0 ? (
            ""
          ) : (
            <div className="alert alert-warning small p-2 me-3 ms-2 mb-1">
              <i className="fas fa-exclamation-triangle me-2"></i>
              {trans(
                "You need to select at lease one CSW service from the CSW services tab"
              )}
            </div>
          )}
          <PerfectScrollbar className="p-2 pe-3 mb-2 scrollbar-recaclulate">
            <div className="card">
              <div className="card-header">
                <label className="small">{trans("What")}</label>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">{trans("Title")}</span>
                    <input
                      className="form-control form-control-sm"
                      value={cswcriteria.title ? cswcriteria.title : ""}
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "title",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group  input-group-sm">
                    <span className="input-group-text ">
                      {trans("Abstract")}
                    </span>
                    <input
                      className="form-control form-control-sm "
                      value={cswcriteria.abstract ? cswcriteria.abstract : ""}
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "abstract",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text ">
                      {trans("Identifier")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.resourceidentifier
                          ? cswcriteria.resourceidentifier
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "resourceidentifier",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text ">
                      {trans("Keyword")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={cswcriteria.keyword ? cswcriteria.keyword : ""}
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "keyword",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <select
                  className="form-select form-select-sm mt-2 mb-3"
                  value={
                    cswcriteria.topiccategory ? cswcriteria.topiccategory : ""
                  }
                  onChange={(e) => {
                    store.dispatch({
                      type: "csw/search/criteria",
                      payload: {
                        property: "topiccategory",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="" disbaled>
                    -- {trans("Select thematic category (ISO 19115)")} --
                  </option>
                  <option value="imageryBaseMapsEarthCover">
                    {trans("Imagery BaseMaps Earth Cover")}
                  </option>
                  <option value="biota">{trans("Biota")}</option>
                  <option value="environment">{trans("Environment")}</option>
                  <option value="farming">{trans("Farming")}</option>
                  <option value="boundaries">{trans("Boundaries")}</option>
                  <option value="climatologyMeteorologyAtmosphere">
                    {trans("Climatology Meteorology Atmosphere")}
                  </option>
                  <option value="economy">{trans("Economy")}</option>
                  <option value="elevation">{trans("Elevation")}</option>
                  <option value="geoscientificInformation">
                    {trans("Geoscientific Information")}
                  </option>
                  <option value="intelligenceMilitary">
                    {trans("Intelligence Military")}
                  </option>
                  <option value="health">{trans("Health")}</option>
                  <option value="inlandWaters">{trans("Inland Waters")}</option>
                  <option value="location">{trans("Location")}</option>
                  <option value="locatoceansion">{trans("Oceans")}</option>
                  <option value="planningCadastre">
                    {trans("Planning Cadastre")}
                  </option>
                  <option value="society">{trans("Society")}</option>
                  <option value="structure">{trans("Structure")}</option>
                  <option value="transportation">
                    {trans("Transportation")}
                  </option>
                  <option value="utilitiesCommunication">
                    {trans("Utilities Communication")}
                  </option>
                </select>
              </div>
            </div>
            <div className="card mt-2">
              <div className="card-header">
                <label className="small">{trans("Where")}</label>
              </div>
              <div className="card-body">
                <div className="mb-2">
                  <div className="input-group">
                    <select
                      className="form-select form-select-sm mt-2"
                      value={cswcriteria.where ? cswcriteria.where : ""}
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "where",
                            value: e.target.value,
                          },
                        });
                      }}
                    >
                      <option value="everywhere">{trans("Everywhere")}</option>
                      <option value="mapinteraction">
                        {trans("Map interaction")}
                      </option>
                      <option value="drawsquare">{trans("Draw square")}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mt-2">
              <div className="card-header">
                <label className="small">{trans("When")}</label>
              </div>
              <div className="card-body">
                <div className="mb-2">
                  <div className="input-group input-group-sm w-100">
                    <span className="input-group-text ">{trans("From")}</span>
                    {DatetimeEditor(null, true)}
                  </div>
                </div>
                <div className="mb-2">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text ">{trans("To")}</span>
                    {DatetimeEditor(null, true)}
                  </div>
                </div>
                <select
                  className="form-select form-select-sm mt-2 mb-3"
                  value={
                    cswcriteria.calendartype ? cswcriteria.calendartype : ""
                  }
                  onChange={(e) => {
                    store.dispatch({
                      type: "csw/search/criteria",
                      payload: {
                        property: "calendartype",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="" disbaled>
                    -- {trans("Select criteria")} --
                  </option>
                  <option value="tempExtentDate">
                    {trans("Temp Extent Date")}
                  </option>
                  <option value="creationDate">{trans("Creation Date")}</option>
                  <option value="revisionDate">{trans("Revision Date")}</option>
                  <option value="publicationDate">
                    {trans("Publication Date")}
                  </option>
                </select>
              </div>
            </div>
            <div className="card mt-2">
              <div className="card-header">
                <label className="small">{trans("Source type")}</label>
              </div>
              <div className="card-body">
                <select
                  className="form-select form-select-sm mt-2"
                  value={cswcriteria.type ? cswcriteria.type : ""}
                  onChange={(e) => {
                    store.dispatch({
                      type: "csw/search/criteria",
                      payload: {
                        property: "type",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="">{trans("All")}</option>
                  <option value="dataset">{trans("Geospatial data")}</option>
                  <option value="series">
                    {trans("Geospatial data series")}
                  </option>
                  <option value="service">{trans("Service")}</option>
                </select>
              </div>
            </div>
            <div
              className="mt-2  "
              onClick={() => {
                setTimeout(window["recaclulatePerfectScrollbarHeight"], 200);
              }}
            >
              <span
                className="small pointer"
                data-bs-target="#csw-advanced-criteria"
                data-bs-toggle="collapse"
              >
                {trans("Advance criteria")}
                <i className="fas fa-chevron-down ms-1"></i>
              </span>
            </div>
            <div className="card mt-2 collapse" id="csw-advanced-criteria">
              <div className="card-header">
                <label className="small">{trans("Advance criteria")}</label>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Responsible part")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.organisationname
                          ? cswcriteria.organisationname
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "organisationname",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <select
                  className="form-select form-select-sm mt-2 mb-3"
                  value={
                    cswcriteria.responsiblepartyrole
                      ? cswcriteria.responsiblepartyrole
                      : ""
                  }
                  onChange={(e) => {
                    store.dispatch({
                      type: "csw/search/criteria",
                      payload: {
                        property: "responsiblepartyrole",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="" disbaled>
                    -- {trans("Select responsible part role")} --
                  </option>
                  <option value="all">{trans("All")}</option>
                  <option value="author">{trans("Author")}</option>
                  <option value="custodian">{trans("Custodian")}</option>
                  <option value="distributor">{trans("Distributor")}</option>
                  <option value="notdefined">{trans("Not defined")}</option>
                  <option value="originator">{trans("Originator")}</option>
                  <option value="owner">{trans("Owner")}</option>
                  <option value="pointOfContact">
                    {trans("Point of contact")}
                  </option>
                  <option value="principalInvestigator">
                    {trans("Principal Investigator")}
                  </option>
                  <option value="processor">{trans("Processor")}</option>
                  <option value="publisher">{trans("Publisher")}</option>
                  <option value="resourceProvider">
                    {trans("Resource Provider")}
                  </option>
                  <option value="user">{trans("User")}</option>
                </select>

                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Access and use terms")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.conditionapplyingtoaccessanduse
                          ? cswcriteria.conditionapplyingtoaccessanduse
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "conditionapplyingtoaccessanduse",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Public constrains")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.accessconstraints
                          ? cswcriteria.accessconstraints
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "accessconstraints",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">{trans("Origin")}</span>
                    <input
                      className="form-control form-control-sm"
                      value={cswcriteria.lineage ? cswcriteria.lineage : ""}
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "lineage",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Specification compliance")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.specificationtitle
                          ? cswcriteria.specificationtitle
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "specificationtitle",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Denominator")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.denominator ? cswcriteria.denominator : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "denominator",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Distance value")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.distancevalue
                          ? cswcriteria.distancevalue
                          : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "distancevalue",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="input-group input-group-sm ">
                    <span className="input-group-text ">
                      {trans("Distance UoM")}
                    </span>
                    <input
                      className="form-control form-control-sm"
                      value={
                        cswcriteria.distanceuom ? cswcriteria.distanceuom : ""
                      }
                      onChange={(e) => {
                        store.dispatch({
                          type: "csw/search/criteria",
                          payload: {
                            property: "distanceuom",
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <select
                  className="form-select form-select-sm mt-2 mb-3"
                  value={cswcriteria.degree ? cswcriteria.degree : ""}
                  onChange={(e) => {
                    store.dispatch({
                      type: "csw/search/criteria",
                      payload: {
                        property: "degree",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="" disbaled>
                    -- {trans("Select degree")} --
                  </option>
                  <option value="Not evaluated">
                    {trans("Not evaluated")}
                  </option>
                  <option value="true">{trans("Conformant")}</option>
                  <option value="false">{trans("Not Conformant")}</option>
                </select>
              </div>
            </div>
            <div className="mt-2 text-end">
              <button
                className="btn btn-sm btn-white rounded border me-2"
                onClick={() => {
                  store.dispatch({ type: "csw/search/criteria/clear" });
                }}
              >
                {trans("Clear")}
              </button>
              <button
                className="btn btn-sm btn-success text-white"
                onClick={search}
                disabled={cswcriteria?.services?.length > 0 ? false : true}
              >
                {trans("Search")}
              </button>
            </div>
          </PerfectScrollbar>
        </div>
        <div className="tab-pane fade  " role="tabpanel" id="cws-services">
          <PerfectScrollbar className="scrollbar-recaclulate">
            <BootstrapTable
              key={key()}
              keyField="id"
              data={cswServices}
              columns={[
                {
                  dataField: "id",
                  hidden: true,
                  text: "",
                },
                {
                  dataField: "name",
                  text: "Name",
                },
                {
                  dataField: "url",
                  text: "URL",
                },
              ]}
              wrapperClasses="bg-white"
              striped
              hover
              selectRow={selectRow}
            />
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
}

export default CSWPanel;
